export const GET_TEST = 'GET_TEST';
export const GET_TEST_SUCCESS = 'GET_TEST_SUCCESS';
export const GET_TEST_FAILED = 'GET_TEST_FAILED';

export const VALIDATE_TEST = 'VALIDATE_TEST';
export const VALIDATE_TEST_SUCCESS = 'VALIDATE_TEST_SUCCESS';
export const VALIDATE_TEST_FAILED = 'VALIDATE_TEST_FAILED';
